import React from 'react';
import './card.css';

type CardProps = {
  className?: string;
  children?: React.ReactNode;
};

const Card: React.FC<CardProps> = ({ className = '', children }) => {
  return <div className={`card-component ${className}`}>{children}</div>;
};

export default Card;
